import { render, staticRenderFns } from "./VersionChecker.vue?vue&type=template&id=294d3399&"
import script from "./VersionChecker.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VersionChecker.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports